import { useApplication } from './use-application';

export const useEnvironment = () => {
	return useApplication((state) => state.application.env);
};
